import React, { Component } from 'react';
import { HomeTemplate } from './../../Templates';
import { connect } from 'react-redux';
import { apiConsumtions, apiRepayments } from '../../Api/Repayment/Repayment';
import { apiMedadomURL } from '../../Api/Affiliate/Medadom'
import * as moment from 'moment';
import { COLOR_TABLE } from '../../Config/Config';
import Store from '../../Redux/Store';
import getMemberTypeCode from '../../Utils/getMemberTypeCode';
import DocumentsService from '../../Services/DocumentsService';
import { apiGetHealthService } from '../../Api/HealthService/HealthService';
import { HealthServiceEnum } from '../../Config/enums';
import useHasContractFamily from '../../Utils/Functions';
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seriesVisionGlobal: [
        // {
        //   legend: 'Remboursement CGRM',
        //   data: 348,
        //   color: '#FF8AD8'
        // },
        // {
        //   legend: 'Sécurité sociale',
        //   data: 130,
        //   color: '#FF6722'
        // },
        // {
        //   legend: 'Reste à charge',
        //   data: 42,
        //   color: '#1313C6'
        // }
      ],
      contractFamily: Store.getState().auth.user?.contractTypes,
      garanteeValue: 0,
      manegementValue: 0,
      manegementComentary: '',
      garanteeComentary: '',
      modalSentShow: false,
      hideManegementComentary: false,
      hideGaranteeComentary: false,
      remboursement: [],
      remboursementLoadingDone: false,
      profile: Store.getState().profile.profile,
      medadomModalOpen: false,
      medadomModalStep: 1
    };
  }

  ratingChange = (value, key) => {
    this.setState({
      [key]: value
    });
  };

  ratingGaranteeChange = (value) => {
    this.setState({
      garanteeValue: value,
      hideGaranteeComentary: value != 0 ? true : false
    });
  };

  ratingManegementChange = (value) => {
    this.setState({
      manegementValue: value,
      hideManegementComentary: value != 0 ? true : false
    });
  };

  manegementSendClicked = () => {
    this.setState({
      hideManegementComentary: false
    });
  };

  garanteeSendClicked = () => {
    const action = {
      type: 'RATING_MODAL_SHOW',
      value: false
    };
    this.props.dispatch(action);
    this.setState({
      garanteeValue: 0,
      manegementValue: 0,
      manegementComentary: '',
      garanteeComentary: '',
      modalSentShow: true,
      hideManegementComentary: false,
      hideGaranteeComentary: false
    });
  };

  ratingModalShowClicked = () => {
    const action = {
      type: 'RATING_MODAL_SHOW',
      value: true
    };
    this.props.dispatch(action);
  };

  ratingModalHide = () => {
    const action = {
      type: 'RATING_MODAL_SHOW',
      value: false
    };
    this.props.dispatch(action);
    this.setState({
      garanteeValue: 0,
      manegementValue: 0,
      manegementComentary: '',
      garanteeComentary: '',
      modalSentShow: false,
      hideManegementComentary: false,
      hideGaranteeComentary: false
    });
  }; 

  getRemboursementData = async (skip, limit) => {
      const { beginDate, endDate } = this.getDate(new Date().getFullYear());
      let tempBeginDate = this.props.user.memberId ? new Date(parseInt(this.props.user.memberId.substring(0, 8), 16) * 1000) : 0;
      const { data, status } = await apiRepayments(
        this.props.user?.memberNumber, // modif
        getMemberTypeCode(this.props.user?.memberType),
        moment(tempBeginDate).format('MM/DD/YYYY'), // modif
      moment(endDate).format('MM/DD/YYYY'), // modif
      skip,
      limit,
      true
    );
    if (status == 200) {
      console.log('data remb', data)
      this.setState({
        remboursementLoadingDone: true,
        remboursement: [...data]
      });
    }
  };

  getConsumption = async (beginDate, endDate) => {
    const resGlobal = await apiConsumtions(
      this.props.user?.memberNumber, // modif
      0,
      moment(beginDate).format('MM/DD/YYYY'),
      moment(endDate).format('MM/DD/YYYY')
    );
    if (resGlobal.status == 200 && resGlobal.codeRetour) {
      const { codeRetour, postes, beneficiaires, status, ...restGlobal } =
        resGlobal;
      this.setState({
        seriesVisionGlobal: [
          {
            legend: 'Remboursement SPVIE',
            data: restGlobal.rbcgrm,
            color: COLOR_TABLE[0]
          },
          {
            legend: 'Sécurité sociale',
            data: restGlobal.rbss,
            color: COLOR_TABLE[1]
          },
          {
            legend: 'Reste à charge',
            data: restGlobal.rac,
            color: COLOR_TABLE[2]
          }
        ]
      });
    }
  };

  getDate = (fullYear) => {
    // modif
    // return {
    //   beginDate: `01/01/2012`,
    //   endDate: `12/31/2012`
    // };
    return {
      beginDate: `01/01/${fullYear}`,
      endDate: `12/31/${fullYear}`
    };
  };

  componentDidMount() {
    const { beginDate, endDate } = this.getDate(new Date().getFullYear());
     const isPProfileSante = useHasContractFamily("SANTE");
    if (isPProfileSante) {
      this.getConsumption(beginDate, endDate);
       this.getRemboursementData(0, 2);
    }
    DocumentsService.getAllCategoriesSilently();
  }

  remboursementClicked = () => {
    let tempBeginDate = this.props.user.memberId ? new Date(parseInt(this.props.user.memberId.substring(0,8), 16)*1000) : new Date('01/01/2012')
    this.props.history.push({
      pathname: '/remboursement',
      state: {
        beginDate: tempBeginDate,
        endDate: new Date(),
        status: 'remboursement'
      }
    });
  };

  remboursementMobileClicked = () => {
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width < 768) {
      this.remboursementClicked();
    }
  };

  ProfilMobileClicked = () => {
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width < 768) {
      this.CheckProfil();
    }
  };

  ContactMobileClicked = () => {
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width < 768) {
      this.Contact();
    }
  };

  SendBillMobileClicked = () => {
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width < 768) {
      this.SendBill();
    }
  };

  SendBill = async() => {
    const bankCategory = await DocumentsService.getParentCategoryByName('Facture');
    this.props.history.push('/documents/send', {
      goToCategory: bankCategory
    })
  };

  CheckProfil = () => {
    this.props.history.push({
      pathname: '/profile'
    });
  };

  Contact = () => {
    this.props.history.push({
      pathname: '/contact',
      state: { status: 'Nous contacter' }
    });
  };

  openLinkInNewTab = (url) => {
    window.open(url, '_blank', 'noreferrer')
  }

  onPressMedadomTeleconsultation = async () => {
    const res = await apiMedadomURL()

    if (res.status === 200) {
        this.onCloseMedadomModal()
        this.openLinkInNewTab(res.data)
    }
  }

  onPressGeolocateAroundMe = () => {
    this.onCloseMedadomModal()
    setTimeout(() => {
      this.props.history.push('/geolocation/select')
    }, 300)
  }

  onOpenMedadomModal = () => { 
    this.setState({medadomModalOpen: true, medadomModalStep: 1})
    this.props.history.push({
      pathname: '/',
      search: `?category=medadom`
    })
  }
  onCloseMedadomModal = () => { 
    this.setState({medadomModalOpen: false});
    this.props.history.push({
      pathname: '/',
      search: ``
    })
  }
  onNextStepMedadomModal = () => { 
    this.setState({medadomModalStep: 2});
    this.props.history.push({
      pathname: '/',
      search: `?category=medadom&subcategory=local`
    })
  }

  getHealthService = async () => {
    const res = await apiGetHealthService();
    if (res.status === 200) {
      switch (res.typeService) {
        case HealthServiceEnum.SANTECLAIR:
        case HealthServiceEnum.ITELIS:
	  	  case HealthServiceEnum.CARTEBLANCHE:
        case HealthServiceEnum.KALIVIA:
        case HealthServiceEnum.KALIXIA:
          this.openLinkInNewTab(res.linkService)
          this.onCloseMedadomModal()
          break;
        default:
          alert("Impossible d'utiliser le réseau de soins pour localiser un praticien.")
          break;
      }
    } else {
      alert("Impossible d'utiliser le réseau de soins pour localiser un praticien.")
    }
  }

  render() {
    return (
      <HomeTemplate
        seriesVisionGlobal={this.state.seriesVisionGlobal}
        garanteeValue={this.state.garanteeValue}
        ratingChange={this.ratingChange}
        manegementValue={this.state.manegementValue}
        manegementComentary={this.state.manegementComentary}
        manegementSendClicked={this.manegementSendClicked}
        garanteeSendClicked={this.garanteeSendClicked}
        garanteeComentary={this.state.garanteeComentary}
        ratingModalShowClicked={this.ratingModalShowClicked}
        ratingModalHide={this.ratingModalHide}
        hideGaranteeComentary={this.state.hideGaranteeComentary}
        hideManegementComentary={this.state.hideManegementComentary}
        ratingGaranteeChange={this.ratingGaranteeChange}
        ratingManegementChange={this.ratingManegementChange}
        modalSentShow={this.state.modalSentShow}
        remboursement={this.state.remboursement}
        remboursementLoadingDone={this.state.remboursementLoadingDone}
        remboursementClicked={this.remboursementClicked}
        sendBill={this.SendBill}
        contractFamily={this.state.contractFamily}
        CheckProfil={this.CheckProfil}
        Contact={this.Contact}
        remboursementMobileClicked={this.remboursementMobileClicked}
        SendBillMobileClicked={this.SendBillMobileClicked}
        ProfilMobileClicked={this.ProfilMobileClicked}
        ContactMobileClicked={this.ContactMobileClicked}
        history={this.props.history}

        medadomModalOpen={this.state.medadomModalOpen}
        medadomModalStep={this.state.medadomModalStep}
        onOpenMedadomModal={this.onOpenMedadomModal}
        onCloseMedadomModal={this.onCloseMedadomModal}
        onNextStepMedadomModal={this.onNextStepMedadomModal}

        onPressMedadomTeleconsultation={this.onPressMedadomTeleconsultation}
        onPressMedadomUseHealthService={this.getHealthService}
        onPressGeolocateAroundMe={this.onPressGeolocateAroundMe}
        currentUser={this.props.user}
      />
    );
  }
}
const mapStateToProps = (state) => ({
  rating: state.rating,
  user: state.auth.user
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: (action) => {
      dispatch(action);
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
